module.exports = __webpack_public_path__ + "static/img/mifi15.f53dac73.png";